export default function ResizeHandle({ onResize, onResizeEnd }) {
  const handleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const th = e.currentTarget.closest('th');
    const startX = e.clientX;
    const startW = th ? th.getBoundingClientRect().width : 150;
    let latestW = startW;

    const onMove = (ev) => {
      const delta = ev.clientX - startX;
      const w = Math.max(20, Math.round(startW + delta));
      latestW = w;
      if (th) {
        th.style.width = `${w}px`;
        th.style.minWidth = `${w}px`;
      }
      onResize?.(w);
    };
    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      if (latestW !== startW) onResizeEnd?.(latestW);
    };
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  };

  return (
    <div
      onMouseDown={handleMouseDown}
      onClick={(e) => e.stopPropagation()}
      className="absolute top-0 h-full cursor-col-resize group/rh z-20"
      style={{ right: '-4px', width: '8px' }}
      title="Arrastar para redimensionar"
    >
      <div className="absolute left-1/2 -translate-x-1/2 top-0 h-full w-0.5 bg-transparent group-hover/rh:bg-accent group-active/rh:bg-accent transition-colors" />
    </div>
  );
}
